import BMPImage from '../../assets/icons/icon_bmp.svg'
import DefaultImage from '../../assets/icons/icon_default.svg'
import DOCImage from '../../assets/icons/icon_doc.svg'
import DOCXImage from '../../assets/icons/icon_docx.svg'
import GIFImage from '../../assets/icons/icon_gif.svg'
import JPGImage from '../../assets/icons/icon_jpg.svg'
import PDFImage from '../../assets/icons/icon_pdf.svg'
import PNGImage from '../../assets/icons/icon_png.svg'
import RTFImage from '../../assets/icons/icon_rtf.svg'
import TIFImage from '../../assets/icons/icon_tif.svg'
import TXTImage from '../../assets/icons/icon_txt.svg'
import XLSImage from '../../assets/icons/icon_xls.svg'
import XLSXImage from '../../assets/icons/icon_xlsx.svg'
import { FileTypes } from '../types/FileTypes'

export const fileIcons = {
  [FileTypes.BMP]: BMPImage,
  [FileTypes.MSWORD]: DOCImage,
  [FileTypes.DOCX]: DOCXImage,
  [FileTypes.GIF]: GIFImage,
  [FileTypes.JPG]: JPGImage,
  [FileTypes.JPEG]: JPGImage,
  [FileTypes.PDF]: PDFImage,
  [FileTypes.PNG]: PNGImage,
  [FileTypes.RTF]: RTFImage,
  [FileTypes.TIFF]: TIFImage,
  [FileTypes.TXT]: TXTImage,
  [FileTypes.MSEXCEL]: XLSImage,
  [FileTypes.XLSX]: XLSXImage,
  UNKNOWN: DefaultImage
}
